const env = {
  API_PATH: process.env.GATSBY_API_PATH,
  APP_DOMAIN: process.env.GATSBY_APP_DOMAIN,
  GRAPHQL_PATH: process.env.GATSBY_GRAPHQL_PATH,
  GOOGLE_ANALYTICS_ID: process.env.GATSBY_GOOGLE_ANALYTICS_ID,
  GOOGLE_TAG_MANAGER_CONTAINER_ID:
    process.env.GATSBY_GOOGLE_TAG_MANAGER_CONTAINER_ID,
  SENTRY_URL: process.env.GATSBY_SENTRY_URL,
  SENTRY_ENVIRONMENT: process.env.GATSBY_SENTRY_ENVIRONMEN,
  SENTRY_RELEASE: process.env.GATSBY_UIZARD_DEPLOYED_VERSIO,
  COOKIE_DOMAIN: process.env.GATSBY_COOKIE_DOMAIN,
  COOKIE_SECURE: process.env.GATSBY_COOKIE_SECUR,
  RECAPTCHA_SITE_KEY: process.env.GATSBY_RECAPTCHA_SITE_KE,
};

export default env;
